import request from '../../client';
import {
  DrupalProductReviewRatings,
  PiiEncryptionKeyResponse,
} from '../../utils/productReviews/types';

/**
 * Fetch product review ratings API IDs from Drupal Commerce Product records
 * given a filter query string.
 */
const getProductReviewRatings = (
  filterQueryString: string,
): Promise<DrupalProductReviewRatings> =>
  request({
    host: window.drupalSettings?.pur_api?.drupalBase,
    uri: `commerce_product?${filterQueryString}`,
    options: {
      method: 'GET',
    },
    authToken: false,
  }) as Promise<DrupalProductReviewRatings>;

/**
 * Fetch the Bazaarvoice PII public encryption key from Drupal.
 */
const getPiiEncryptionKey = (): Promise<PiiEncryptionKeyResponse> =>
  request({
    host: window.drupalSettings?.pur_api?.drupalBase,
    uri: 'bazaarvoice/pii-encryption-key',
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
      },
      body: JSON.stringify({}),
    },
    authToken: false,
  }) as Promise<PiiEncryptionKeyResponse>;

/**
 * Service Object
 */
const productReviewsService = {
  getProductReviewRatings,
  getPiiEncryptionKey,
};

export default productReviewsService;